var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('converter',{attrs:{"conversionType":"vector","title":"Vector File Conversion","prependIcon":"file_upload","iconClass":"blue-grey white--text","urlInput":false}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5dffa963","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/converter/VectorFileConverter.vue
// module id = 275
// module chunks = 1